import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {BelegDTO} from '../../openapi/beleg-openapi';

export const belegEntitiesAdapter: EntityAdapter<BelegDTO> = createEntityAdapter<BelegDTO>();
